import * as moment from 'moment'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatPaginatorIntl } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from './native.date.adapter';
import { saveAs } from "file-saver";
import { constUrpi, urpiweb } from './constants';
import * as shajs from 'sha.js';
import { HttpHeaders } from '@angular/common/http';

export function getIndexBy(array: Array<{}>, { name, value }): number {
  for (let i = 0; i < array.length; i++) {
    if (array[i][name] === value) {
      return i;
    }
  }
  return -1;
}

/**
  * Metodo que valida si es un correo valido.
  */
 export function validateMail(mail) {
  let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(mail);
}

export function isEmpty(text: any) {
  let result = false
  if(!text || text == undefined || text == null || text == "" || (text.toString()).trim() == "") {
    result = true
  }
  return result
}

export function isEmptyCollection(list: any []) {
  let result = false
  if(!list || list == undefined || list == null || list == [] || list.length == 0) {
    result = true
  }
  return result
}

export function isNumber(n) { 
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n); 
} 

export function numberOnly(event): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

export function letterOnly(event): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if ((charCode < 97 || charCode > 122)//letras mayusculas
      && (charCode < 65 || charCode > 90) //letras minusculas
      && (charCode != 45) //retroceso
      && (charCode != 241) //ñ
        && (charCode != 209) //Ñ
        && (charCode != 32) //espacio
        && (charCode != 225) //á
        && (charCode != 233) //é
        && (charCode != 237) //í
        && (charCode != 243) //ó
        && (charCode != 250) //ú
        && (charCode != 193) //Á
        && (charCode != 201) //É
        && (charCode != 205) //Í
        && (charCode != 211) //Ó
        && (charCode != 218)) { //Ú
      return false;
  }
  return true;
}

export function aplphaNumberOnly(event): boolean {
  let charCode = (event.which) ? event.which : event.keyCode;
  let specialKeys = [32, 209, 241, 225, 233, 237, 243, 250, 193, 201, 205, 211, 218];
  if (specialKeys.indexOf(charCode) != -1) {
    return true;
  }  
  if ((charCode < 65 || charCode > 122) && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

export function getCurrentDate(): Date {
  var date = new Date();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  let dateString = `${year}-${month}-1`
  return new Date(dateString);
}

export function getMomentDate(dateAt: any, format?: string) {
  if(!format)
    format = 'YYYYMMDD'
  return moment(dateAt).format(format) 
}

export function getDateAdapter(): any {
  return [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }
  ];
}

export function downLoadFile(data: any, fileName: string, typeDoc?: string) {    
  let blob = null
  if(typeDoc) {
      blob = new Blob([data], {type: typeDoc});
  } else {
      blob = new Blob([data]);
  }
  
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);            
  } else {
      saveAs(blob, fileName);       
  }
}

export function formatAmount(amount: any, fixed?: any) {
  if(!fixed) {
    fixed = 2;
  }
  return (isNaN(amount) ? 0.00 : parseFloat(amount).toFixed(fixed));
}

export function string64ConverttoBlob(dataURI) {
  var byteString = atob(dataURI);
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  var bb = new Blob([ab]);
  return bb;
}

export function createHash(message: string) {
  let data = new TextEncoder().encode(message);
  let hashBuffer = shajs('sha256').update(data).digest();
  let int8Array = Array.from(new Int8Array(hashBuffer));
  return btoa(String.fromCharCode.apply(null, new Uint8Array(int8Array)));
}

export function hashString(objects: any[]) {
  let arrayRequest = [];
  let stringRequest = "";
  arrayRequest.push(constUrpi.hashKey);
  objects = arrayRequest.concat(objects); 
  for(let i=0; i<objects.length; i++) {
    stringRequest += objects[i];
  }
  let hash = createHash(stringRequest)
  return hash;
}

export function getLoadFileHeaders() {  
  let token = urpiweb.auth.token;
  return new HttpHeaders({  
    "Accept": "application/json",
    'Ocp-Apim-Subscription-Key': urpiweb.auth.ocpkey, 
    'authorization': token ? `Bearer ${token}` : '',
    'VERSION-APP': urpiweb.auth.versionApp,
     // "Access-Control-Allow-Origin": "http://localhost:4200",
    'VERSION-APP-PREVIOUS': urpiweb.auth.versionAppPrevious,
  /*   // 🔒 Headers de seguridad (normalmente se colocan en el servidor)
  "X-Frame-Options": "DENY",
  "X-Content-Type-Options": "nosniff",
  "Strict-Transport-Security": "max-age=63072000; includeSubDomains; preload",
  "Content-Security-Policy": "default-src 'self'",
  "Referrer-Policy": "no-referrer",
  "Permissions-Policy": "camera=(), microphone=(), geolocation=()",
  "Cross-Origin-Embedder-Policy": "require-corp",
  "Cross-Origin-Resource-Policy": "same-origin",
  "Cross-Origin-Opener-Policy": "same-origin" */
  });
}

export function completeZerosLeft(text: any, length: number) {
  let value = text.toString();
  return (value.length < length) ? completeZerosLeft("0" + value, length) : value;
}

export function getDutchPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  
  paginatorIntl.itemsPerPageLabel = 'Registros por página:';
  paginatorIntl.nextPageLabel = 'Siguiente página';
  paginatorIntl.previousPageLabel = 'Volver página';
  paginatorIntl.getRangeLabel = dutchRangeLabel;
  
  return paginatorIntl;
}

const dutchRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { 
    return `0 de ${length}`; 
  }  
  length = Math.max(length, 0);
  const startIndex = page * pageSize;
  const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
  return `${startIndex + 1} - ${endIndex} de ${length}`;
}

export function exceedSizeFile(file, size) {
  var fileSize = file.size / 1024 / 1024;
  if (fileSize > size) {
      return true;
  } else {
    return false;
  }
}

export function isTypeFile(file, type) {
  if (file.type == type) {
      return true;
  } else {
    return false;
  }
}